export const parseRedirectUri = (redirectUri: string, tenantCode: string, code?: string, temporaryMfaSetup: boolean = false, purpose: string = undefined): string => {

  const uri = new URL(redirectUri)

  uri.searchParams.append('tenantCode', tenantCode)

  if (code) {
    uri.searchParams.append('code', code)
  }

  if (temporaryMfaSetup) {
    uri.searchParams.append('temporaryMfaSetup', 'true')
  }

  if (purpose) {
    uri.searchParams.append('purpose', purpose)
  }

  return uri.toString()

}
